import { useNavigate } from 'react-router-dom'

import { Banner, Button, Image, Text } from '@/ui'
import { TypographyStyles } from '@/styles'
import { useReselector } from '@/utils/sharedHooks'
import { selectCurrentAnnualTaxYear } from '@/features/admin/annual-tax-details/annualTaxDetails.selector'

export const NextYearTaxCenter = () => {
  const navigate = useNavigate()
  const taxYear = useReselector(selectCurrentAnnualTaxYear)

  return (
    <div className="flex flex-col items-center">
      <Image
        src="https://heard-images.s3.amazonaws.com/assets/annual_taxes_background.svg"
        alt="plant"
        height={310}
        width={310}
      />
      <Text
        variant={TypographyStyles.DISPLAY_MD}
        textAlign="center"
        className="mt-10"
      >
        Looking for annual tax guidance?
      </Text>

      <Text
        variant={TypographyStyles.BODY_SM}
        textAlign="center"
        className="mt-4"
      >
        Check back in December for the kickoff to our {taxYear} tax season, and
        we&apos;ll be here to help guide the way. Later this year, we&apos;ll
        ask you a few questions that will help us personalize your {taxYear} tax
        season experience.
      </Text>

      <div className="mt-10 justify-center flex">
        <Button onClick={() => navigate('/dashboard')}>Go to Home</Button>
      </div>

      <div className="mt-10">
        <Banner
          text="Looking for prior year tax returns? You can find them in the Tax Return Archive "
          ctaText="Go"
          onClick={() => navigate('/taxes/archive')}
        />
      </div>
    </div>
  )
}
